import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/modules/auth/stores/authStore'

interface PublicRouteProps {
  children: React.ReactNode
}

/**
 * Wraps public-only routes (e.g. login).
 * If the user is already authenticated, redirect them to the dashboard.
 */
export function PublicRoute({ children }: PublicRouteProps) {
  const { status, isAuthenticated } = useAuthStore()

  if (status === 'checking') {
    return null
  }

  if (isAuthenticated) {
    return <Navigate to="/clients" replace />
  }

  return <>{children}</>
}
